(function AdzukiMediaHub($, Adzuki)
{
	'use strict';

	const component = {
		emits: ['close-modal', 'selected-media'],
		props: {
			section: {
				type    : String,
				required: true,
			},
			selectionLimit: {
				type   : Number,
				default: 0,
			},
			showModal: {
				type    : Boolean,
				required: true,
				default : false,
			},
			showUploadTab: {
				type   : Boolean,
				default: true,
			}
		},
		data() {
			return {
				baseUri    : Adzuki.base_uri,
				mediaHubUrl: Adzuki.mediahub_url,
				media      : [],
				mediaProps : {
					showUploadTab: this.showUploadTab,
				},
				sectionInfo        : {},
				// Media Hub terms gate (MEDIA-288): nothing is browsed until they're accepted
				tos                : '',
				tosVideoUrl        : '',
				tosVideoCaptionsUrl: '',
				tosAgreed          : false,
				tosChecked         : false,
			};
		},
		methods: {
			closeMediaModal() {
				this.$emit('close-modal');
			},
			async openPicker() {
				const agreed = await this.checkTos();

				if (agreed) {
					this.loadPicker();
				} else {
					this.getTos();
				}
			},
			loadPicker() {
				this.getMedia();
				this.getSectionInfo();
			},
			async checkTos() {
				try {
					const response = await Adzuki.Ajax.get(`${this.baseUri}/Media/checkTos`);

					this.tosAgreed = Boolean(response && response.agreed);
				} catch (error) {
					console.error('Error checking Media Terms and Conditions:', error);
					this.tosAgreed = false;
				} finally {
					this.tosChecked = true;
				}

				return this.tosAgreed;
			},
			async getTos() {
				try {
					const response = await Adzuki.Ajax.get(`${this.baseUri}/Media/getTos`);

					if (response) {
						this.tos                 = response.tos || '';
						this.tosVideoUrl         = response.videoUrl || '';
						this.tosVideoCaptionsUrl = response.captionsUrl || '';
					}
				} catch (error) {
					console.error('Error fetching Media Terms and Conditions:', error);
				}
			},
			// adzuki-tos saves the acknowledgment itself, then the media load in the same modal
			handleTos() {
				this.tosAgreed = true;
				this.loadPicker();
			},
			async getMedia() {
				try {
					const url      = `${this.baseUri + '/Media/getMediaItems/' + this.section}`;
					const response = await Adzuki.Ajax.get(url);

					if (!response) {
						return Adzuki.StatusMessage('error', 'Error retrieving media items: No response from server');
					}

					this.media = response;
					this.mediaProps.media = this.media;

					Adzuki.MediaUrls.resolveAll(this.media).catch((error) => {
						console.error('Error loading media URLs:', error);
					});
				} catch (error) {
					return Adzuki.StatusMessage('error', `Error retrieving media items: ${error.message}`);
				}
			},
			async getSectionInfo() {
				try {
					const url      = `${this.baseUri + '/MediaSection/getSection/' + this.section}`;
					const response = await Adzuki.Ajax.get(url);

					if (!response) {
						return Adzuki.StatusMessage('error', 'Error retrieving media sections: No response from server');
					}

					this.sectionInfo = response;
					if (this.selectionLimit > 0) {
						this.sectionInfo.upload_limit = Math.min(
							Number(this.sectionInfo.upload_limit) || this.selectionLimit,
							this.selectionLimit
						);
					}
					this.mediaProps.sectionInfo = this.sectionInfo;
				} catch (error) {
					return Adzuki.StatusMessage('error', `Error retrieving media sections: ${error.message}`);
				}
			},
			selectMedia(media) {
				this.$emit('selected-media', media);

				this.closeMediaModal();
			}
		},
		watch: {
			showModal(newVal) {
				if (newVal) {
					// check the terms, then load media and section info, when the modal is opened
					this.openPicker();
				}
			}
		},
		template: `
			<div v-if="showModal && !tosAgreed" class="modal-component" @click.self="closeMediaModal">
				<div class="modal-component-content">
					<div class="modal-component-header">
						<span class="close" @click="closeMediaModal">&times;</span>
						<h4>Maxx Media File Manager</h4>
					</div>
					<div class="modal-component-body">
						<adzuki-loading v-if="!tosChecked"></adzuki-loading>
						<adzuki-tos
							v-else
							:title="'Media Submission Terms and Conditions'"
							:terms-conditions="tos"
							:video-url="tosVideoUrl"
							:captions-url="tosVideoCaptionsUrl"
							@accepted="handleTos"
						></adzuki-tos>
					</div>
				</div>
			</div>
			<template v-if="showModal && tosAgreed">
				<adzuki-modal
					:modal-title="'Maxx Media File Manager'"
					:type="'component'"
					:component-name="'adzuki-select-files'"
					:component-props="mediaProps"
					@close-modal="closeMediaModal"
					@component-event="selectMedia"
				></adzuki-modal>
			</template>
		`,
		mounted() {
			this.mediaProps.media         = this.media;
			this.mediaProps.sectionInfo   = this.sectionInfo;
			this.mediaProps.showUploadTab = this.showUploadTab;

			if (this.showModal) {
				this.openPicker();
			}
		},
	};

	Adzuki.VueComponents.AdzukiMediaHub = component;
}(jQuery, window.Adzuki || {}));
